import { strategyMap } from './strategies';

/**
 * Factory function that creates an updater function for "when" blocks.
 *
 * Based on the block's node type, it transforms the block into an API-ready format.
 * Currently supports transformation for geofence node types.
 * If the block type is not recognized, the block is returned unchanged.
 *
 * @param {Object} controllerData - Controller data required for block transformation.
 * @param {Array<Object>} controllerData.devices - List of devices.
 * @param {Array<Object>} controllerData.items - List of device items.
 * @returns {function(Object): Object} A function that accepts a `whenBlock` and returns a new transformed block.
 *
 * @example
 * const updateWhenBlock = createWhenBlockUpdater(controllerData);
 * const updatedBlock = updateWhenBlock(whenBlock);
 */
export const createWhenBlockUpdater = (controllerData) => (whenBlock) => {
    const blockType = whenBlock?.blockMeta?.nodeType;
    const strategy = strategyMap[blockType];

    if (!strategy) {
        return whenBlock;
    }

    return strategy({ whenBlock, controllerData });
};
